import React from "react";
import { Layout, Menu, theme } from "antd";
import { Outlet } from "react-router-dom";
const { Header, Content, Footer } = Layout;

const NewInspection = () => {
  return (
    <div>
      <Layout className="layout" style={{ minHeight: "100vh" }}>
        <Content
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            minWidth: "100%",
            overflow: "initial",
        
            // position: "fixed"
          }}
        >
          <Outlet />
        </Content>

       
      </Layout>
    </div>
  );
};

export default NewInspection;
